import { useEffect, useState } from "react";
import { Button, Card, Col, Row, Spinner } from "react-bootstrap";
import Table from 'react-bootstrap/Table';
import { useLocation } from "react-router-dom";
import { TradeReportServices } from "../../services/TradeReportServices";
import "../custom.css";

function TradeHodiyu() {
    const location = useLocation();  
    const  {adminId,userId}  = location.state || {}; 
  
    const [tradeHodiyu, setTradeHodiyu] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {

        if (adminId) {
            let requestData = {};

            if (userId) {
                requestData = { adminId, userId };
            } else {
                requestData = { adminId };
            }


            TradeReportServices.getTradeHodiyu(requestData).then((res) => {
                if (res.code === 1) {
                    setTradeHodiyu(res.data.tradeHodiyuList);
                    setLoading(false);
                } else {
                    setLoading(false);
                }
            }).catch((error) => {
                setLoading(false); 
            });
        }
    }, [adminId]);
    
    

    return (
        <div>
            <Card className="mb-5">
                <Card.Body>
                    <Row>
                        <Col className="text-right">
                            <Button variant="success">PRINT</Button>
                        </Col>
                    </Row>

                    {loading ? (
                        <Row className="justify-content-center">
                            <Col className="text-center">
                                <Spinner animation="border" role="status" />
                            </Col>
                        </Row>
                    ) : (
                        <>
                            {tradeHodiyu && (
                                <>
                                    <Row>
                                        <Col>Trade Hodiyu</Col>
                                        <Col className="center-header">{tradeHodiyu.valan}</Col>
                                        <Col className="text-right">{tradeHodiyu.date}</Col>
                                    </Row>

                                    {tradeHodiyu.userTrades && tradeHodiyu.userTrades.length > 0 ? (
                                        tradeHodiyu.userTrades.map((userTrade, index) => (
                                            <div key={index}>
                                                <Table bordered hover responsive>
                                                    <thead className="header">
                                                        <tr className="yellow-row">
                                                            <th colSpan={5} className="text-center">{userTrade.user}</th>
                                                        </tr>
                                                        <tr>
                                                            <th>Script Name</th>
                                                            <th>Buy</th>
                                                            <th>Sell</th>
                                                            <th>Gross Total</th>
                                                            <th>Net Buy/Sell</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {userTrade.trades.map((trade, tradeIndex) => (
                                                            <tr key={tradeIndex}>
                                                                <td>{trade.script}</td>
                                                                <td>{trade.buy.toLocaleString()}</td>
                                                                <td>{trade.sell.toLocaleString()}</td>
                                                                <td>{trade.grossTotal.toLocaleString()}</td>
                                                                <td>{trade.netBuySell.toLocaleString()}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                    <tfoot>
                                                        <tr className="gray-background fss-1">
                                                            <td></td>
                                                            <td>{userTrade.buyTotal.toLocaleString()}</td>
                                                            <td>{userTrade.sellTotal.toLocaleString()}</td>
                                                            <td>{userTrade.grossTotal.toLocaleString()}</td>
                                                            <td>{userTrade.netTotal.toLocaleString()}</td>
                                                        </tr>
                                                    </tfoot>
                                                </Table>
                                            </div>
                                        ))
                                    ) : (
                                        <p>No trades available</p>
                                    )}
                                </>
                            )}
                        </>
                    )}
                </Card.Body>
            </Card>
        </div>
    );
}

export default TradeHodiyu;
